import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { usePageHeader } from "../contexts/PageHeaderContext";
import BreadCrumb from "../components/common/BreadCrumb";
import { Tabs } from "../components/ui";
import { BuildingOfficeIcon } from "@heroicons/react/24/outline";

const orgTabs = [
  { value: "companies", label: "Companies", href: "/dashboard/organization" },
  {
    value: "subscription",
    label: "Subscription & Usage",
    href: "/dashboard/organization/subscription",
  },
];

const Organization = () => {
  const { user } = useAuth();
  const { setHeaderContent } = usePageHeader();
  const { pathname } = useLocation();
  const isOrgOwner = !!user?.organizationId;

  useEffect(() => {
    const isSubscription = pathname === "/dashboard/organization/subscription";
    setHeaderContent(
      <div>
        <BreadCrumb
          items={
            isSubscription
              ? [
                  { label: "Dashboard", href: "/dashboard" },
                  { label: "Organization", href: "/dashboard/organization" },
                  { label: "Subscription & Usage" },
                ]
              : [
                  { label: "Dashboard", href: "/dashboard" },
                  { label: "Organization" },
                ]
          }
          className="mb-2"
        />
        <h1 className="font-heading text-xl sm:text-2xl font-bold text-gray-900">
          Organization
        </h1>
        <p className="text-sm text-gray-600 max-w-2xl mt-1">
          Manage your organization details, companies, and subscription.
        </p>
      </div>,
    );
    return () => setHeaderContent(null);
  }, [setHeaderContent, pathname]);

  if (!isOrgOwner) {
    return (
      <div className="flex flex-col items-center justify-center min-h-[400px] text-center p-8 bg-white rounded-3xl shadow-sm">
        <BuildingOfficeIcon className="w-12 h-12 text-gray-300 mb-4" />
        <h2 className="text-base font-semibold text-gray-700">
          Access Restricted
        </h2>
        <p className="text-sm text-gray-500 mt-1">
          Only organization admins can access organization settings.
        </p>
      </div>
    );
  }

  return (
    <div>
      <Tabs tabs={orgTabs} value={pathname} />
      <div className="bg-white h-screen">
        <div className="">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default Organization;
